import { axiosInstance as request } from '@/api/rest.service'

export const getCreateData = context => request.get(`/to-dos/create?context=${context}`)
export const getStates = () => request.get('to-dos/states')
export const getTemplates = () => request.get('/to-dos/templates')
export const todoApi = (method, url, payload) => request[method](url, payload)

export const getTodoDetails = todoId => request.get(`/to-dos/${todoId}?include=checklistItems,comments,media`)
export const getCheckLists = todoId => request.get(`/to-dos/${todoId}/checklist-items`)
export const createCheckList = (todoId, payload) => request.post(`/to-dos/${todoId}/checklist-items`, payload)
export const updateCheckList = (todoId, checkListId, payload) =>
  request.put(`/to-dos/${todoId}/checklist-items/${checkListId}`, payload)
export const deleteCheckList = (todoId, checkListId) =>
  request.delete(`/to-dos/${todoId}/checklist-items/${checkListId}`)

export const deleteFile = (todoId, fileId) => request.delete(`/to-dos/${todoId}/files/${fileId}`)
export const uploadFile = (todoId, payload) => request.post(`/to-dos/${todoId}/files`, payload)

export const createComment = (todoId, payload) => request.post(`/to-dos/${todoId}/comments`, payload)
export const updateComment = (todoId, commentId, payload) =>
  request.put(`/to-dos/${todoId}/comments/${commentId}`, payload)
export const deleteComment = (todoId, commentId) => request.delete(`/to-dos/${todoId}/comments/${commentId}`)
